import { makeStyles } from 'tss-react/mui';

export const BREAK_POINT = 1320;

export default makeStyles({ name: 'Heading' })((theme) => ({
    root: {
        display: 'flex',
        gap: 4,
        padding: '16px 0',
        borderBottom: '1px solid #E0E0E0',
        minHeight: 48,
        marginBottom: 48,
        [theme.breakpoints.down(BREAK_POINT)]: {
            marginBottom: 20,
            padding: 16
        }
    },
    _vertical: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start'
    },
    _horizontal: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    header: {
        fontSize: 24,
        margin: 0
    }
}));
